import React from 'react';
import Base from './Base';

type ButtonProps = React.ComponentProps<typeof Base>;

const Success: React.FC<ButtonProps> = ({ className, ...rest }) => {
    const classes = ['btn--outline-success', className].filter(Boolean).join(' ');
    return <Base className={classes} {...rest} />;
};

export default Success;
